exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.hidden[data-v-e497ec34] {\r\n    display: none;\n}\n.preview[data-v-e497ec34] {\r\n    width: 80px;\r\n    height: 30px;\r\n    border: 1px dashed gray;\r\n    text-align: center;\n}\r\n\r\n", ""]);

